/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const BlockquoteIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="BlockquoteIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M4.70711 7.02738H6C6.55228 7.02738 7 7.4751 7 8.02738V10.0274C7 10.5797 6.55229 11.0274 6 11.0274H4C3.44772 11.0274 3 10.5797 3 10.0274V7.32027L6.14645 4.17383L6.85355 4.88093L4.70711 7.02738Z"
                fill="currentColor"
              />
              <path
                d="M10.7071 7.02738H12C12.5523 7.02738 13 7.4751 13 8.02738V10.0274C13 10.5797 12.5523 11.0274 12 11.0274H10C9.44772 11.0274 9 10.5797 9 10.0274V7.32027L12.1464 4.17383L12.8536 4.88093L10.7071 7.02738Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

BlockquoteIcon.tags = ['quote', 'text', 'speech', 'citation'];

BlockquoteIcon.category = 'Tags';

BlockquoteIcon.iconSize = 16;
